<!-- Header da Página -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-file-edit"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'relatorios.texts.titulo' | translate }}</h1>
    <p class="header-subtitle">{{ 'relatorios.texts.subtitulo' | translate }}</p>
  </div>
</div>

<div class="relatorios-container">

  <!-- LADO ESQUERDO: Relatório selecionado -->
  <div class="relatorios-content">
    <app-relatorio-vendas *ngIf="selectedReport === 'relatorioVendas'"></app-relatorio-vendas>
    <app-relatorio-itens-vendidos *ngIf="selectedReport === 'relatorioItensVendidos'"></app-relatorio-itens-vendidos>
    <app-relatorio-produtos *ngIf="selectedReport === 'relatorioProdutos'"></app-relatorio-produtos>
    <app-relatorio-contas-pagas *ngIf="selectedReport === 'relatorioContasPagas'"></app-relatorio-contas-pagas>
    <app-relatorio-contas-recebidas
      *ngIf="selectedReport === 'relatorioContasRecebidas'"></app-relatorio-contas-recebidas>
    <app-relatorio-contas-a-pagar *ngIf="selectedReport === 'relatorioContasAPagar'"></app-relatorio-contas-a-pagar>
    <app-relatorio-contas-a-receber
      *ngIf="selectedReport === 'relatorioContasAReceber'"></app-relatorio-contas-a-receber>
    <app-relatorio-dre *ngIf="selectedReport === 'relatorioDRE'"></app-relatorio-dre>
  </div>

  <!-- LADO DIREITO: Sidebar com os relatórios -->
  <div class="relatorios-sidebar">
    <div class="sidebar-card">
      <div class="sidebar-header">
        <div class="sidebar-header-icon">
          <i class="pi pi-list"></i>
        </div>
        <span class="sidebar-header-title">{{ 'relatorios.texts.menu' | translate }}</span>
      </div>
      <div class="sidebar-content">
        <p-accordion [multiple]="true" [activeIndex]="[0,1,2,3]">

          <!-- VENDAS -->
          <p-accordionTab header="{{ 'relatorios.categorias.vendas' | translate }}">
            <ul class="report-list">
              <li class="report-item" *ngIf="podeVer('relatorioVendas')" [class.active]="selectedReport === 'relatorioVendas'"
                (click)="selectReport('relatorioVendas')">
                <div class="report-item-icon">
                  <i class="pi pi-chart-bar"></i>
                </div>
                <span>{{ 'relatorios.spans.relatorio_de_vendas' | translate }}</span>
              </li>
              <li class="report-item" *ngIf="podeVer('relatorioItensVendidos')" [class.active]="selectedReport === 'relatorioItensVendidos'"
                (click)="selectReport('relatorioItensVendidos')">
                <div class="report-item-icon">
                  <i class="pi pi-inbox"></i>
                </div>
                <span>{{ 'relatorios.spans.relatorio_de_itens_vendidos' | translate }}</span>
              </li>
            </ul>
          </p-accordionTab>

          <!-- ESTOQUE -->
          <p-accordionTab header="{{ 'relatorios.categorias.estoque' | translate }}">
            <ul class="report-list">
              <li class="report-item" *ngIf="podeVer('relatorioProdutos')" [class.active]="selectedReport === 'relatorioProdutos'"
                (click)="selectReport('relatorioProdutos')">
                <div class="report-item-icon estoque-icon">
                  <i class="pi pi-list"></i>
                </div>
                <span>{{ 'relatorios.spans.lista_de_produtos' | translate }}</span>
              </li>
            </ul>
          </p-accordionTab>

          <!-- FINANCEIRO -->
          <p-accordionTab header="{{ 'relatorios.categorias.financeiro' | translate }}">
            <ul class="report-list">
              <li class="report-item" *ngIf="podeVerExtratoDeCaixa()" routerLink="/lista-de-movimentos">
                <div class="report-item-icon financeiro-icon">
                  <i class="pi pi-book"></i>
                </div>
                <span>{{ 'relatorios.spans.extrato_de_contas' | translate }}</span>
              </li>
              <li class="report-item" *ngIf="podeVer('relatorioContasPagas')" [class.active]="selectedReport === 'relatorioContasPagas'"
                (click)="selectReport('relatorioContasPagas')">
                <div class="report-item-icon financeiro-icon">
                  <i class="pi pi-wallet"></i>
                </div>
                <span>{{ 'relatorios.spans.relatorio_de_despesas_pagas' | translate }}</span>
              </li>
              <li class="report-item" *ngIf="podeVer('relatorioContasAPagar')" [class.active]="selectedReport === 'relatorioContasAPagar'"
                (click)="selectReport('relatorioContasAPagar')">
                <div class="report-item-icon financeiro-icon">
                  <i class="pi pi-credit-card"></i>
                </div>
                <span>{{ 'relatorios.spans.relatorio_de_contas_a_pagar' | translate }}</span>
              </li>
              <li class="report-item" *ngIf="podeVer('relatorioContasRecebidas')" [class.active]="selectedReport === 'relatorioContasRecebidas'"
                (click)="selectReport('relatorioContasRecebidas')">
                <div class="report-item-icon financeiro-icon">
                  <i class="pi pi-dollar"></i>
                </div>
                <span>{{ 'relatorios.spans.relatorio_de_contas_recebidas' | translate }}</span>
              </li>
              <li class="report-item" *ngIf="podeVer('relatorioContasAReceber')" [class.active]="selectedReport === 'relatorioContasAReceber'"
                (click)="selectReport('relatorioContasAReceber')">
                <div class="report-item-icon financeiro-icon">
                  <i class="pi pi-receipt"></i>
                </div>
                <span>{{ 'relatorios.spans.relatorio_de_contas_a_receber' | translate }}</span>
              </li>
            </ul>
          </p-accordionTab>

          <!-- CONTÁBIL -->
          <p-accordionTab header="{{ 'relatorios.categorias.contabil' | translate }}">
            <ul class="report-list">
              <li class="report-item" *ngIf="podeVer('relatorioDRE')" [class.active]="selectedReport === 'relatorioDRE'"
                (click)="selectReport('relatorioDRE')">
                <div class="report-item-icon contabil-icon">
                  <i class="pi pi-chart-line"></i>
                </div>
                <span>{{ 'relatorios.spans.relatorio_dre' | translate }}</span>
              </li>
            </ul>
          </p-accordionTab>

        </p-accordion>
      </div>
    </div>
  </div>
</div>
